module.exports = __webpack_public_path__ + "img/support.f22f62eb.svg";